import useSWR from 'swr';
import { getAvaliacoesByPac } from '../services/avaliacao';

export default function useAvaliacoes(codPac) {
  return useSWR(codPac ? ['avaliacoes', codPac] : null, () =>
    getAvaliacoesByPac(codPac)
  );
}
